import { render, staticRenderFns } from "./AspectRatioVerticalIcon.vue?vue&type=template&id=343e4cdb&scoped=true"
import script from "./AspectRatioVerticalIcon.vue?vue&type=script&lang=js"
export * from "./AspectRatioVerticalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343e4cdb",
  null
  
)

export default component.exports